'use client'
import type { FC, ReactNode } from 'react'
import { customTheme } from '#/src/custom/styles/theme'
import { ChakraProvider } from '@chakra-ui/react'
import { SetInitialColorMode } from 'ui/storefront'

interface ChakraProviderNextProps {
  children: ReactNode
}

const ChakraProviderNext: FC<ChakraProviderNextProps> = ({ children }) => {
  return (
    <ChakraProvider resetCSS theme={customTheme}>
      <SetInitialColorMode
        initialColorMode={
          customTheme.config.initialColorMode === 'system'
            ? 'light'
            : customTheme.config.initialColorMode
        }
      />
      {children}
    </ChakraProvider>
  )
}

export default ChakraProviderNext
